import script from "./not-found-redirect-component.vue?vue&type=script&lang=ts&setup=true"
export * from "./not-found-redirect-component.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__